import { Component, OnInit } from '@angular/core';
import { ProducerService } from '@sc/pas-common';
import { AuthService } from '@sc/pas-common';
import { SingleSignatureCreditAccess } from './models/SingleSignatureCreditAccess';
import { AuthGuardService } from '@sc/pas-common';

@Component({
  selector: 'sc-single-signature-credit',
  templateUrl: './single-signature-credit.component.html',
  styleUrls: ['./single-signature-credit.component.scss']
})

export class SingleSignatureCreditComponent implements OnInit {

  public producers: any[];
  public openMenu = false;
  public notAllowedCuit = false;
  public selectedBranchIcon = '';
  public loading = false;
  public selectorTitle = 'Seleccione un productor';

  constructor(private producerService: ProducerService,
    private authGuardService: AuthGuardService,
    private auth: AuthService) { }

  ngOnInit() {
  }

  openPASSelector()
  {
    this.loading = true;
    this.producerService.getByUserID(this.authGuardService.user).subscribe(producers => {
      this.producers = producers;
      this.openMenu = true;
    });
  }

  handleOnPasClick(producer) {
    this.openMenu = false;
    this.auth.generateSingleSignatureCreditAccess(producer.cuit).subscribe((response: SingleSignatureCreditAccess) => {
      this.loading = false;
      if (response.url) {
        window.open( response.url, '_blank');
      }
      else {
        this.notAllowedCuit = true;
      }
    },
      error => {
        this.loading = false;
        console.log('response', error);
      })
  }

  closeLateralMenu() {
    this.loading = false;
    this.openMenu = false;
  }
}
